require('./dependencies.js');
require('./scss/homegroup/style.scss');
require('./scss/affiliate/main.scss');
require('./scss/landfinder/main.scss');
require('./scss/siteworks/main.scss');

//include js and css
// todo add code to make sure there is a file before running (then remoove empty files)
function requireAll(r) {
    r.keys().forEach(r);
}
requireAll(require.context('./js/', true, /\.js$/));
requireAll(require.context('./css/', true, /\.s|css$/));
requireAll(require.context('./svgSprites/', true, /\.(svg)$/));
